const Function = require('core/src/function');
const crypto = require('crypto');
const Language = require('core/src/language').default;
const _ = require('lodash');

const Hash = Function.extend(Function, 'Hash');

/**
 * Custom validator for hashing algorithms.
 * @param {string} value - The algorithm string to validate.
 * @returns {boolean} - True if the algorithm is supported, false otherwise.
 */
const isValidAlgorithm = (value) => crypto.getHashes().includes(value);

const isStringOrArrayOfStrings = (value) => _.isString(value)
	|| (_.isArray(value) && _.every(value, _.isString));

Hash.prototype.onInit = function (dependencies) {
	this.language = dependencies.get(Language);
	this.setParameters({
		'$data': undefined,
		'algorithm': 'sha256'
	});

	// Add model validation
	this.setModelValidation({
		data: [isStringOrArrayOfStrings, this.language.translate('Data must be a string or an array of strings.')],
		algorithm: [isValidAlgorithm, this.language.translate("Algorithm must be a valid hashing algorithm supported by this environment (e.g., 'sha256', 'md5').")]
	});
};

Hash.prototype.onExecute = function () {
	const data = this.getInput('data');
	const algorithm = this.getInput('algorithm');

	// Defensive checks
	if (!isStringOrArrayOfStrings(data)) {
		this.error(this.language.translate('Data must be a string or an array of strings.'));
		return;
	}

	if (!isValidAlgorithm(algorithm)) {
		this.error(this.language.translate("Algorithm must be a valid hashing algorithm supported by this environment."));
		return;
	}

	try {
		const dataArray = _.isArray(data) ? data : [data];
		const result = _.map(dataArray, (item) => {
			const hash = crypto.createHash(algorithm);
			hash.update(item);
			return hash.digest('hex');
		});

		this.executeTriggers({
			type: 'success',
			data: result
		});
	} catch (e) {
		this.error(e);
	}
};

module.exports = Hash;